import React, { useEffect, useState } from 'react';
interface CountdownProps {
  initialHours?: number;
  initialMinutes?: number;
  initialSeconds?: number;
  className?: string;
  theme?: 'light' | 'dark' | 'danger' | 'silver';
}
export function Countdown({
  initialHours = 23,
  initialMinutes = 27,
  initialSeconds = 35,
  className = '',
  theme = 'danger'
}: CountdownProps) {
  const [timeLeft, setTimeLeft] = useState({
    hours: initialHours,
    minutes: initialMinutes,
    seconds: initialSeconds
  });
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        if (prev.hours === 0 && prev.minutes === 0 && prev.seconds === 0) {
          clearInterval(timer);
          return prev;
        }
        let newSeconds = prev.seconds - 1;
        let newMinutes = prev.minutes;
        let newHours = prev.hours;
        if (newSeconds < 0) {
          newSeconds = 59;
          newMinutes -= 1;
        }
        if (newMinutes < 0) {
          newMinutes = 59;
          newHours -= 1;
        }
        return {
          hours: newHours,
          minutes: newMinutes,
          seconds: newSeconds
        };
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  const formatNumber = (num: number) => num.toString().padStart(2, '0');
  const themes = {
    light: 'bg-white text-navy-950 border-silver',
    dark: 'bg-navy-900 text-white border-silver/30',
    danger: 'bg-navy-950 text-silver-light border-silver/40',
    silver: 'bg-silver-light text-navy-950 border-silver-dark'
  };
  const units: Array<{
    value: number;
    label: string;
  }> = [{
    value: timeLeft.hours,
    label: 'hs'
  }, {
    value: timeLeft.minutes,
    label: 'min'
  }, {
    value: timeLeft.seconds,
    label: 'seg'
  }];
  return <div className={`inline-flex items-center gap-2 font-mono font-bold text-lg md:text-2xl px-4 py-2 rounded-lg border ${themes[theme]} ${className}`} role="timer" aria-label="Tiempo restante de la oferta" data-id="element-333" data-mp="27a5ackbulvt0">
      {units.map((unit, i) => <React.Fragment key={unit.label} data-id="element-334" data-mp="2i2dozcte5ova" data-mpi={i}>
          {i > 0 && <span className="opacity-50 pb-4" data-id="element-335" data-mp="2i0u8pm7qjdti">:</span>}
          <div className="flex flex-col items-center" data-id="element-336" data-mp="2d315n21qazxg">
            <span data-id="element-337" data-mp="2qvhbeam0lc22">{formatNumber(unit.value)}</span>
            <span className="text-[10px] uppercase tracking-wider opacity-70 font-sans" data-id="element-338" data-mp="2qu7azerovrs9">
              {unit.label}
            </span>
          </div>
        </React.Fragment>)}
    </div>;
}